import type { HTMLAttributes, Ref } from 'react'

interface ContentPaperProps extends HTMLAttributes<HTMLDivElement> {
  columnCount?: number
  columnFill?: string
}

const ContentPaper = ({ columnCount = 1, columnFill = 'balanced', ...props }: ContentPaperProps) => (
  <div
    {...props}
    style={{
      display: 'block',
      /** @see https://www.smashingmagazine.com/2019/01/css-multiple-column-layout-multicol/ */
      ...(columnCount > 1
        ? {
            columnWidth: 'auto',
            columnCount,
            columnGap: '1em',
            columnRule: '2px solid var(--tuna-palette-divider)',
            columnFill: columnFill as never,
            height: '100%',
          }
        : {}),
      padding: 8,
      transition: 'margin 195ms cubic-bezier(0.4, 0, 0.6, 1)',
      ...props.style,
    }}
  />
)

export interface ContentLayoutProps extends HTMLAttributes<HTMLDivElement> {
  className?: string
  size: 'small' | 'medium' | 'large'
  columns?: number
  columnFill?: 'auto' | 'balanced'
  ref?: Ref<HTMLDivElement>
}

export const ContentLayout = (props: ContentLayoutProps) => {
  const { className, children, columns = 1, columnFill, size = 'large', style, ref, ...restProps } = props

  return (
    <div
      {...restProps}
      style={{
        fontSize: size === 'small' ? '0.8rem' : size === 'medium' ? '1rem' : '1.2rem',
        flex: 1,
        overflow: 'auto',
        margin: 'auto',
        width: 'min(1024px, 100%)',
        padding: '16px 32px 16px 32px',
        ...style,
      }}
      ref={ref}
      className={className}
    >
      <ContentPaper columnCount={columns} columnFill={columnFill}>
        {children}
      </ContentPaper>
    </div>
  )
}

export default ContentLayout
